import { FormEvent, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const { session, loading, passwordRecovery, clearPasswordRecovery } = useAuth();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!loading && !session) {
      setMessage('Il link di recupero non è valido o è scaduto. Richiedi una nuova email dalla pagina di accesso.');
    }
  }, [loading, session]);

  const updatePassword = async (event: FormEvent) => {
    event.preventDefault();
    setMessage(null);

    if (!session) {
      setMessage('Sessione di recupero non disponibile. Richiedi una nuova email.');
      return;
    }
    if (password.length < 8) {
      setMessage('La password deve contenere almeno 8 caratteri.');
      return;
    }
    if (password !== confirmPassword) {
      setMessage('Le due password non coincidono.');
      return;
    }

    setBusy(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;

      clearPasswordRecovery();
      await supabase.auth.signOut();
      navigate('/login', {
        replace: true,
        state: { passwordUpdated: true }
      });
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Non è stato possibile aggiornare la password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login-screen">
      <section className="login-card glass">
        <div className="login-logo"><KeyRound size={34} /></div>
        <h1>Nuova password</h1>
        <p className="muted">Inserisci e conferma la nuova password del tuo account.</p>

        {loading ? (
          <p className="message-box">Verifica del link in corso…</p>
        ) : session && passwordRecovery ? (
          <form onSubmit={updatePassword} className="form-stack">
            <label>
              Nuova password
              <input
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                type="password"
                autoComplete="new-password"
                minLength={8}
                required
              />
            </label>
            <label>
              Conferma nuova password
              <input
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                type="password"
                autoComplete="new-password"
                minLength={8}
                required
              />
            </label>
            <button className="primary-button full" disabled={busy}>
              {busy ? 'Aggiornamento…' : 'Aggiorna password'}
            </button>
          </form>
        ) : (
          <Link className="primary-button full" to="/login">Torna alla pagina di accesso</Link>
        )}

        {message && <p className="message-box">{message}</p>}
      </section>
    </main>
  );
}
